import { type ComponentPropsWithoutRef, type ReactElement, type ReactNode } from 'react'

import { Text } from '@components/ui-core/text/text'

export interface FigureProps extends ComponentPropsWithoutRef<'figure'> {
  caption?: ReactNode | string
}

export function Figure({ children, caption, ...rest }: FigureProps): ReactElement {
  return (
    <figure {...rest}>
      {children}
      {caption && <Text as="figcaption">{caption}</Text>}
    </figure>
  )
}
